import { makeOrderResponseMessages } from './makeOrderResponse';

const {
  DECLINED_BY_BANK,
  GENERIC_ERROR,
  MISSING_ERROR,
  NOT_ENOUGH_FUNDS,
  PAYMENT_DETAILS_ERROR,
  PRECONDITIONS_VALIDATION_FAILED,
  TECHNICAL_ERROR,
  THREE_D_FAILURE,
  USE_ANOTHER_CARD,
  CART_RESTART_FROM_SEARCH,
  PRICE_CHANGE_SHOW_CUSTOMER,
  CART_FAIL_CART,
} = makeOrderResponseMessages;

export const errorMessageToTextKeyId = {
  [DECLINED_BY_BANK]: 'BankDecline',
  [GENERIC_ERROR]: 'GenericError',
  [MISSING_ERROR]: 'MissingError',
  [NOT_ENOUGH_FUNDS]: 'InsufficientBalance',
  [PAYMENT_DETAILS_ERROR]: 'WrongDetails',
  [PRECONDITIONS_VALIDATION_FAILED]: 'ExceedsMaxAttemptsError',
  [TECHNICAL_ERROR]: 'TechnicalError',
  [THREE_D_FAILURE]: 'IdentificationFailure',
  [USE_ANOTHER_CARD]: 'InvalidCard',
  [CART_RESTART_FROM_SEARCH]: 'FailedCart',
  [PRICE_CHANGE_SHOW_CUSTOMER]: 'PriceChangeError',
  [CART_FAIL_CART]: 'InvalidCart',
} as const;
